import ArticleAdd from '../views/Article/Add';
import ArticleCate from '../views/Article/Cate';
import ArticleLists from '../views/Article/Lists';
import Upload from '../views/Article/Upload';
import Sort from '../views/Article/Sort';
import Special from '../views/Article/Special';
import FictCate from '../views/Article/FictCate';
import UpdateIndex from '../views/Article/UpdateIndex';
import AddCate from '../views/Article/AddCate';
import MAP from '../views/Article/map.vue';
import Pend from '../views/Article/Pend.vue';
import Contrast from '../views/Article/Contrast.vue';
import Imp from '../views/Article/Imp.vue';

let Article = [
  {
    path: 'Add',
    name: '添加文章',
    component: ArticleAdd
  },
  {
    path: 'Cate',
    name: '栏目管理',
    component: ArticleCate
  },
  {
    path: 'AddCate',
    name: '栏目设置',
    component: AddCate
  },
  {
    path: 'Lists',
    name: '稿件库',
    component: ArticleLists
  },
  {
    path: 'Upload',
    name: '文件上传',
    component: Upload
  },
  {
    path: 'Sort',
    name: '文章排序',
    component: Sort
  },
  {
    path: 'Special',
    name: '文章专题',
    component: Special
  },
  {
    path: 'FictCate',
    name: '虚拟栏目树',
    component: FictCate
  },
  {
    path: 'UpdateIndex',
    name: '首页发布',
    component: UpdateIndex
  },
  {
    path: 'MAP',
    name: '栏目映射',
    component: MAP
  },
  {
    path: 'Pend',
    name: '待审稿库',
    component: Pend
  },
  {
    path: 'Contrast',
    name: '文章对比',
    component: Contrast
  },
  {
    path: 'Imp',
    name: '批量导入',
    component: Imp
  }
];

export default Article;
